import { render, staticRenderFns } from "./User-Breadcrumb.vue?vue&type=template&id=03c80f03&"
import script from "./User-Breadcrumb.vue?vue&type=script&lang=js&"
export * from "./User-Breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports